// Школы с общим конкурсом: претендент, выбравший одну из них основной,
// автоматически участвует в конкурсе и во второй. Вторая школа для физмата
// зависит от пола.
const ATYRAU_BOYS = 'c7bdbed6-74d9-497d-bc8b-33c63b5d46e5';
const SARAISHYK_BOYS = '66bc4da5-2b2f-4236-a039-34c9e4fc9c2f';
const KYZYLORDA_BOYS = 'c63398f4-1cca-4d97-b664-fdb37bff7487';
const KYZYLORDA_GIRLS = 'fdbd96c4-9d5e-489e-b098-1abaf1237b69';
const KYZYLORDA_PHYSMAT = '13d17c3c-ae74-45ee-80a2-cfedc2a2c5fd';

export const getSecondSchool = (school, gender) => {
  switch (school) {
    case ATYRAU_BOYS:
      return SARAISHYK_BOYS;
    case SARAISHYK_BOYS:
      return ATYRAU_BOYS;
    case KYZYLORDA_BOYS:
    case KYZYLORDA_GIRLS:
      return KYZYLORDA_PHYSMAT;
    case KYZYLORDA_PHYSMAT:
      return { M: KYZYLORDA_BOYS, F: KYZYLORDA_GIRLS }[gender] ?? null;
    default:
      return null;
  }
};

// school_options заявки: JSON-массив школ после основной
export const toSchoolOptions = (school, gender) => {
  const secondSchool = getSecondSchool(school, gender);
  return secondSchool ? JSON.stringify([secondSchool]) : null;
};
